import React from 'react';
import { Modal, Table, Button } from 'antd';
import styles from './StatisticsModal.less';

const exportCSV = (title, columns, data) => {
  const result = [columns, [], ...data].map(i => i.join(',')).join('\n');
  const href = encodeURI('data:text/csv;charset=GBK,\uFEFF' + result);
  const a = document.createElement('a');
  a.download = `${title}.csv`;
  a.href = href;
  a.click();
};
class StatisticsModal extends React.Component {
  render() {
    const {
      columns,
      dataSource,
      hideModal,
      statisticsModalStatus,
      loading,
      title
    } = this.props;

    return (
      <div>
        <Modal
          visible={statisticsModalStatus}
          onCancel={() => hideModal()}
          closable={false}
          footer={null}
          className={styles.statisticsModalContainer}
          width={'50%'}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '16px 0 24px 0'
            }}
          >
            {title}
            <Button
              type="primary"
              onClick={() =>
                exportCSV(
                  title,
                  columns.map(i => i.title),
                  dataSource.map(i => columns.map(j => i[j.dataIndex]))
                )
              }
            >
              下载列表
            </Button>
          </div>
          <Table
            dataSource={[...dataSource]}
            columns={[...columns]}
            scroll={{ y: 350 }}
            loading={loading}
          />
        </Modal>
      </div>
    );
  }
}
export default StatisticsModal;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsModal.js